var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/parts/loadmymodules',["require", "exports", "common/parts"], function (require, exports, Parts) {
    "use strict";
    var LoadMyModules = (function (_super) {
        __extends(LoadMyModules, _super);
        function LoadMyModules(applications) {
            _super.call(this);
            this._applications = applications;
        }
        LoadMyModules.prototype.process = function (symbol) {
            var _this = this;
            try {
                Q.when(this._applications.readMine())
                    .then(function (data) {
                    _this.output.call(data);
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return LoadMyModules;
    }(Parts.Part));
    return LoadMyModules;
});

